// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBvqo6TqMdWkKuL1Rws1sJIfNO7vgjX5mk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "engagedmanila-aa4b0.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "engagedmanila-aa4b0",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "engagedmanila-aa4b0.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "718611129941",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:718611129941:web:42344121823b729a5756dc",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-9DH7424MC3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
let analytics = null;

// Only initialize analytics in browser environment
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Check if we're in development mode with mock Firebase enabled
const isDevelopment = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_FIREBASE === 'true';

// Mock Firebase services for development
const mockAuth = {
  currentUser: null,
  onAuthStateChanged: (callback) => {
    setTimeout(() => callback(null), 100);
    return () => {};
  },
  createUserWithEmailAndPassword: () => Promise.resolve({ user: { uid: 'mock-uid' } }),
  signInWithEmailAndPassword: () => Promise.resolve({ user: { uid: 'mock-uid' } }),
  signOut: () => Promise.resolve()
};

// Firebase and Firestore initialization complete

// For development, log a warning if using mock Firebase
if (isDevelopment) {
  console.warn('MOCK_FIREBASE flag is set to true, but we are using real Firebase services for security reasons');
}

// Export Firebase services
export { auth, db, storage, analytics };
export default app;